import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Input, Textarea, Button } from "@heroui/react";
import { LuSave } from "react-icons/lu";

const MaterialUnitForm = ({ initialData, onSubmit, isLoading, onCancel }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            name: "",
            description: "",
            ...initialData,
        },
    });

    useEffect(() => {
        if (initialData) {
            reset(initialData);
        }
    }, [initialData, reset]);

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-4"
            noValidate
        >
            <Input
                {...register("name", { required: "Nama satuan wajib diisi" })}
                label="Nama Satuan"
                placeholder="Contoh: Kg, Pcs, Liter"
                variant="bordered"
                errorMessage={errors.name?.message}
                isInvalid={!!errors.name}
                isRequired
            />

            <Textarea
                {...register("description")} // Optional
                label="Deskripsi"
                placeholder="Deskripsi singkat tentang satuan (opsional)"
                variant="bordered"
            />

            <div className="mt-4 flex justify-end gap-2">
                {onCancel && (
                    <Button
                        onPress={onCancel}
                        variant="light"
                        color="danger"
                        size="sm"
                        isDisabled={isLoading}
                    >
                        Batal
                    </Button>
                )}
                <Button
                    color="primary"
                    type="submit"
                    isLoading={isLoading}
                    size="sm"
                    startContent={!isLoading && <LuSave />}
                >
                    Simpan
                </Button>
            </div>
        </form>
    );
};

export default MaterialUnitForm;
